import { render, staticRenderFns } from "./Fixtures.vue?vue&type=template&id=3b1cde5a"
import script from "./Fixtures.vue?vue&type=script&lang=js"
export * from "./Fixtures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports